<template>
  <div class="d-flex align-center justify-space-between">
    <div>Легенда:</div>

    <div class="d-flex">
      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: green }"></v-btn>
            <div class="mt-1">Нормальный</div>
          </template>
          <div style="font-size: 16px">
            <strong>Нормальный уровень психофизиологического состояния</strong> наблюдаемого сотрудника.<br />
            Ему соответствует высокий уровень работоспособности, адекватное реагирование на окружающую среду, отсутствие
            усталости. <br />
            Со стороны руководителя наблюдаемого сотрудника наблюдаемого сотрудника никаких действий не требуется.
          </div>
        </v-tooltip>
      </div>

      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: yellow }"></v-btn>
            <div class="mt-1">Пограничный</div>
          </template>
          <div style="font-size: 16px">
            <strong>«Пограничное» психофизиологическое состояние.</strong><br />
            Сотрудник может находиться в состоянии стресса, переживания, утомленности.<br />
            Его работоспособность постепенно снижается, шанс допущения ошибок в должностных обязанностях возрастает. <br />
            Со стороны руководителя наблюдаемого сотрудника необходимы дополнительный контроль за сотрудником,<br />
            а также сотруднику требуется консультация психолога с целью выяснения причин проявления такого состояния и его
            нормализации.
          </div>
        </v-tooltip>
      </div>

      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: red }"></v-btn>
            <div class="mt-1">Критичный</div>
          </template>
          <div style="font-size: 16px">
            <strong>Критическое психофизиологическое состояние.</strong> <br />
            Сотрудник может находится в состоянии тяжелого стресса, депрессии, нервно-психического напряжения. <br />
            У сотрудника может наблюдаться:
            <ul>
              <li>низкая работоспособность;</li>
              <li>снижен фокус внимания;</li>
              <li>возможна неадекватная реакция на происходящие события;</li>
              <li>несет опасность как себе, так и окружающим.</li>
            </ul>
            Со стороны руководителя наблюдаемого сотрудника необходимы дополнительный контроль за сотрудником,<br />
            включая действия по предоставлению сотруднику кратковременного перерыва в текущей деятельности.<br />
            Также данный сотрудник нуждается во взаимодействии с психологом с целью выяснения причин проявления такого состояния и
            его нормализации.
          </div>
        </v-tooltip>
      </div>
    </div>

    <div></div>
  </div>
</template>

<script>
import { LegendExcessMeasurement } from "@/configs/legenda.js";

export default {
  name: "GroupLegendIndexOfTheResult",

  computed: {
    green() {
      return LegendExcessMeasurement.green;
    },

    yellow() {
      return LegendExcessMeasurement.yellow;
    },

    red() {
      return LegendExcessMeasurement.red;
    },
  },
};
</script>

<style scoped lang="scss">
.v-sheet button.v-btn.btn-legend.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 0 !important;
  height: 20px;
}
</style>
